import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-x', 'IconBrandX', [
  ['path', { d: 'M4 4l11.733 16h4.267l-11.733 -16z', key: 'svg-0' }],
  ['path', { d: 'M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772', key: 'svg-1' }],
]);
